import React, { useEffect } from 'react';

interface ToastProps {
  message: string;
  onClose: () => void;
  duration?: number;
}

const Toast: React.FC<ToastProps> = ({ message, onClose, duration = 4000 }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [onClose, duration]);

  return (
    <div
      style={{
        position: 'fixed',
        left: '50%',
        bottom: 40,
        transform: 'translateX(-50%)',
        background: '#414A4F',
        color: '#F8FAFF',
        padding: '4px 8px',
        borderRadius: 4,
        fontSize: 14,
        zIndex: 99999,
        boxShadow: '0 2px 16px rgba(0,0,0,0.18)',
        minWidth: 200,
        textAlign: 'center',
      }}
    >
      {message}
    </div>
  );
};

export default Toast;
